import { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, TextField, CircularProgress, Alert } from '@mui/material';

const modalStyle = {
    position: 'absolute', top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)', width: 600,
    bgcolor: 'background.paper', border: '2px solid #000',
    boxShadow: 24, p: 4,
};

export default function AddFaqModal({ open, onClose, customer, onSubmit }) {
    const [content, setContent] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (open) {
            setContent('');
            setError('');
        }
    }, [open]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!content) {
            setError('Content is required.');
            return;
        }
        setIsSubmitting(true);
        setError('');

        const payload = {
            client_name: customer.ClientName,
            client_code: customer.ClientCode,
            content: content,
        };
        try {
            await onSubmit(payload);
        } catch (e) {
            setError(e.message || 'An unexpected error occurred.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle} component="form" onSubmit={handleSubmit}>
                <Typography variant="h6" component="h2">Add New FAQ</Typography>
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                <TextField label="Client Name" value={customer ? customer.ClientName : ''} fullWidth disabled sx={{ mt: 2 }}/>
                <TextField label="Client Code" value={customer ? customer.ClientCode : ''} fullWidth disabled sx={{ mt: 2 }}/>
                <TextField
                    label="Content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    fullWidth
                    required
                    multiline
                    rows={4}
                    sx={{ mt: 2 }}
                />
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={onClose} disabled={isSubmitting}>Cancel</Button>
                    <Button type="submit" variant="contained" disabled={isSubmitting}>
                        {isSubmitting ? <CircularProgress size={24} /> : 'Submit'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
